var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 2.33333V18.6667H2.33333V2.33333H18.6667ZM18.6667 0H2.33333C1.05 0 0 1.05 0 2.33333V18.6667C0 19.95 1.05 21 2.33333 21H18.6667C19.95 21 21 19.95 21 18.6667V2.33333C21 1.05 19.95 0 18.6667 0ZM12.9967 10.3367L9.49667 14.8517L7 11.83L3.5 16.3333H17.5L12.9967 10.3367Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoIcon);
export default __webpack_public_path__ + "static/media/photoIcon.248e74f0b3378f747d583e3de64f9ef2.svg";
export { ForwardRef as ReactComponent };